<template>
  <el-dialog
    class="userdetailDialog"
    destroy-on-close
    :close-on-click-modal="false"
    title="订单详情"
    :visible.sync="dialogVisible"
    width="800px"
    @close="close"
  >
    <el-form :model="form" ref="form" v-if="dialogVisible" label-width="140px" size="mini">
      <el-form-item label="订单ID：">
        <span>{{detail.id}}</span>
      </el-form-item>

      <el-form-item label="商户订单ID：">
        <span>{{detail.mch_recharge_id}}</span>
      </el-form-item>

      <el-form-item label="所属商户：">
        <span>{{detail.mch_name}}</span>
      </el-form-item>

      <el-form-item label="用户ID：">
        <span>{{detail.user_id}}</span>
      </el-form-item>

      <el-form-item label="代理账号：" v-if="$store.getters.userinfo.agency_type == 2">
        <span>{{detail.agency_name}}</span>
      </el-form-item>

      <!-- 
          <el-form-item label="所属总代：">
            <span>{{detail.agency_name}}</span>
          </el-form-item>
      -->

      <el-form-item label="订单类型：">
        <span>{{$store.state.app.orderType[detail.source]}}</span>
      </el-form-item>

      <el-form-item label="支付方式：">
        <span>{{$store.state.app.payType[detail.pay_type]}}</span>
      </el-form-item>

      <el-form-item label="收款账号ID：">
        <span>{{detail.receipt_address_id}}</span>
      </el-form-item>

      <el-form-item label="付款人姓名：" v-if="detail.pay_info_ext.account_holder">
        <span>{{detail.pay_info_ext.account_holder}}</span>
      </el-form-item>

      <el-form-item label="付款账号：" v-if="detail.pay_info_ext.account_num">
        <span>{{detail.pay_info_ext.account_num}}</span>
      </el-form-item>

      <el-form-item label="订单金额：">
        <span>{{detail.amount}}</span>
      </el-form-item>

      <el-form-item label="充值金额：">
        <span>{{detail.real_amount}}</span>
      </el-form-item>

      <el-form-item label="到账金额：">
        <span>{{detail.recharge_amount}}</span>
      </el-form-item>

      <el-form-item label="追分金额：">
        <span>{{detail.chased_amount}}</span>
      </el-form-item>

      <el-form-item label="订单状态：">
        <span>{{$store.state.app.orderStatus[detail.status]}}</span>
      </el-form-item>

      <el-form-item label="创建时间：">
        <span>{{detail.created_at}}</span>
      </el-form-item>

      <el-form-item label="完成时间：">
        <span>{{detail.success_at}}</span>
      </el-form-item>

      <el-form-item label="最后更新时间：">
        <span>{{detail.updated_at}}</span>
      </el-form-item>

      <el-form-item label="备注：">
        <span>{{detail.remark}}</span>
      </el-form-item>

      <el-form-item style="width:100%;" align="right">
        <el-button type="primary" @click="cancel">关闭</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      detail: {},
      isUpdateList: false, // 是否更新列表
      form: {},
      dialogVisible: false
    };
  },
  props: {},
  methods: {
    cancel() {
      this.dialogVisible = false;
    },
    open(row) {
      this.dialogVisible = true;
      this.detail = row;
    },
    close() {
      this.detail = {};
      this.$emit("onclose", { update: this.isUpdateList });
      this.isUpdateList = false;
      this.form = {};
    }
  }
};
</script>

<style lang="scss">
.userdetailDialog .el-form-item {
  display: inline-block;
  width: 50%;
  vertical-align: middle;
}
</style>
